import { MutationTree } from 'vuex';
import { ICardListState } from '@/store/interfaces';
import { CardDto } from '@/dto/Card.dto';

export const mutations: MutationTree<ICardListState> = {
  SET_CARD_LIST(state, payload: CardDto[]) {
    state.cardList = payload;
  },
};
